/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:13:35
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/indexList.js
 */
export default {
    // indexList 组件
    indexList: {
        inactiveColor: '#606266',
        activeColor: '#5677fc',
        indexList: [],
        sticky: true,
        customNavHeight: 0,
        safeBottomFix: false
    }
}
